import { List, Record } from 'immutable';
import { Adjustment } from '../../event/models/adjustment';
import { OnyxEvent } from '../../event/models/event';
import { Payment } from '../../event/models/payment';

const PaymentRequestRecord = Record({
  event: null,
  roomCommissions: null,
  adjustments: null,
  finalPayment: null,
});

export class PaymentRequest extends PaymentRequestRecord {
  event: OnyxEvent;
  roomCommissions: number;
  adjustments: List<Adjustment>;
  finalPayment: Payment;
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/payment/model/payment-request.ts